import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { DocumentInterface, IdInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class DocumentApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    loadContract(contractCode: IdInterface): Observable<Transaction<DocumentInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getContractDocuments(contractCode));
    }

    loadClient(clientCode: IdInterface, contractCode?: IdInterface): Observable<Transaction<DocumentInterface[]>> {
        return this.transactionRequest.wrap(this.apiClient.getClientDocuments(clientCode, contractCode));
    }

    detail(document: DocumentInterface): Observable<Transaction<any>> {
        return this.transactionRequest.wrap(this.apiClient.getDocumentDetail(document));
    }

    remove(document: DocumentInterface): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest.wrap(this.apiClient.removeDocument(document)).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }

    upload(code: IdInterface, document: DocumentInterface, isContract = true): Observable<Transaction<void>> {
        return new Observable((observer) => {
            let transaction$ = this.transactionRequest.wrap(this.apiClient.uploadContractDocument(code, document));

            if (!isContract) {
                transaction$ = this.transactionRequest.wrap(this.apiClient.uploadClientDocument(code, document));
            }

            transaction$.subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }

    validate(code: IdInterface, document: DocumentInterface, isContract = true): Observable<Transaction<void>> {
        return new Observable((observer) => {
            let transaction$ = this.transactionRequest.wrap(this.apiClient.validateContractDocument(code, document.id));

            if (!isContract) {
                transaction$ = this.transactionRequest.wrap(this.apiClient.validateClientDocument(code, document.id));
            }

            transaction$.subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }
}
